import i18n from "~/components/i18n";

export default {
  getCreditOptions: (tourPublishCost, multipliers, placeholderText, withTours = false) => {
    if (tourPublishCost === 0) {
      return [];
    }

    const values = [];

    for (let i = 0; i < multipliers.length; i += 1) {
      const number = multipliers[i] * tourPublishCost;

      if (Math.floor(number) === number) {
        /*
         * 1.2 * 15 = 18, we gave people option to buy credits for tour + video
         * 1.2 * 9 = 10.8, if we discount the rate, we can't put fractions in database
         */
        values.push(number);
      }
    }

    const creditOptions = [
      {
        key: "noValue",
        value: "",
        text: placeholderText,
      },
    ];

    for (let i = 0; i < values.length; i += 1) {
      const tourCount = parseInt(values[i] / tourPublishCost, 10);
      const noun = tourCount > 1 ? "tours" : "tour";

      creditOptions.push({
        key: values[i],
        value: values[i],
        text: withTours ? `${values[i]} credits (publish ${tourCount} ${noun})` : `${values[i]} credits`,
      });
    }

    return creditOptions;
  },
  getCreditCardOptions(creditCards) {
    const creditCardOptions = [{ key: "noValue", value: "", text: `(${i18n.t("none")})` }];

    creditCards.forEach(creditCard => {
      creditCardOptions.push({
        key: creditCard.creditCardId,
        value: creditCard.creditCardId,
        text: `${creditCard.cardName} ${creditCard.maskedCardNumber}`,
      });
    });

    return creditCardOptions;
  },
};
